'use strict';

var ElementTools = require('../lib/core/ElementTools.js');
var AFM = require('../lib/animate/FrameManager.js');
var Ease = require('../lib/animate/Ease.js');
var limitNumber = require('../lib/limitNumber.js');
var EventListenerOption = require('../lib/EventListenerOption.js');

var CONTENT_SELECTOR = '.jumpToNextSection__content';

var IS_SETUP_CLASS_NAME = 'isSetup';
var IS_IN_VIEW_CLASS_NAME = 'isInView';


/**
 * @class
 */
function JumpToNextSection(containerElement) {
	this._containerElement = containerElement;
	this._contentElement = containerElement.querySelector(CONTENT_SELECTOR);
	
	this._anim = null;
	this._draw = this._draw.bind(this);
	this._onItemClick = this._onItemClick.bind(this);
	this._onWinScroll = this._onWinScroll.bind(this);
	this.start = this.start.bind(this);
}

JumpToNextSection.COMPONENT_STYLE_CLASS = 'jumpToNextSection';


/**
 * @public
 */
JumpToNextSection.prototype.start = function() {
	window.addEventListener('scroll', this._onWinScroll, EventListenerOption.get());
	this._onWinScroll(); // Call once so measurements are taken and styles updated.
	
	this._containerElement.addEventListener('click', this._onItemClick, false);
	AFM.on('write', this._draw);
	
	this._containerElement.classList.add(IS_SETUP_CLASS_NAME);
}

/**
 * @private
 */
JumpToNextSection.prototype._onWinScroll = function(event) {
	this._containerElementBcr = this._containerElement.getBoundingClientRect();
	this._isStyleNeedUpdating = true;
}

/**
 * @private
 */
JumpToNextSection.prototype._onItemClick = function(event) {
	// Find next section
	var nextSection,
		prevElem,
		curElem = this._containerElement;
	while(curElem = curElem.parentNode) {
		if (curElem.matches('.mainContent')) {
			nextSection = prevElem.nextElementSibling
			break;
		}
		prevElem = curElem;
	}

	// Scroll down to the next section
	if (nextSection !== undefined) {
		var offset = ElementTools.getOffsetSum(nextSection);
		var originY = window.scrollY || window.pageYOffset;
		var destY = offset.top;
		var duration = limitNumber(Math.abs(destY - originY) * 2, 250, 1500);
		
		this._anim = {};
		this._anim.start = {
			x : window.scrollX || window.pageXOffset,
			y : originY,
			time : performance.now()
		};
		this._anim.dest = {
			y : destY
		};
		this._anim.delta = {
			y : this._anim.dest.y - this._anim.start.y,
			time : duration
		};
	}
}


/**
 * @private
 */
JumpToNextSection.prototype._draw = function(event, data) {
	// Update style of arrow if update needed
	if (this._isStyleNeedUpdating === true) {
		var bcr = this._containerElementBcr;
		var heightToMoveBy = bcr.height * 1 / 3;
		var affectiveHeight = bcr.height  - heightToMoveBy;
		var pVis = limitNumber((affectiveHeight + bcr.top) / affectiveHeight, 0, 1);
		
		ElementTools.setTransform(
			this._contentElement,
			'translateY(' + (pVis * heightToMoveBy) + 'px)'
		);
		
		if (pVis <= 0) {
			this._containerElement.classList.remove(IS_IN_VIEW_CLASS_NAME);
		} else {
			this._containerElement.classList.add(IS_IN_VIEW_CLASS_NAME);
		}
		
		this._isStyleNeedUpdating = false;
	}
	
	// Scroll if there is a destination
	if (this._anim !== null) {
		var p = (data.timestamp - this._anim.start.time) / this._anim.delta.time;
		p = Ease.outCubic(limitNumber(p, 0, 1));
		
		var y = this._anim.start.y + (this._anim.delta.y * p);
		
		if (Math.abs(this._anim.dest.y - y) >= 1) {
			window.scroll(this._anim.start.x, y);
		} else {
			window.scroll(this._anim.start.x, this._anim.dest.y);
			this._anim = null;
		}
	}
}


module.exports = JumpToNextSection;

